"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * extracted from ad-config - getPlacementFromAdUnitId 25
 * file is fine, same as prod.
 */
function getPlacementFromAdUnitId(adUnitId) {
    var pattern = /^[A-Za-z0-9_]+-[0-9]+$/g;
    if (adUnitId.match(pattern) === null) {
        throw new Error("Invalid adUnitId: " + adUnitId);
    }
    return adUnitId.split("-")[0];
}
exports.default = getPlacementFromAdUnitId;
